import { Controller } from '@stimulus/core'
import IMask from 'imask'

export default class extends Controller {
  connect() {
    IMask(this.element, {
      mask: Number,
      signed: false,
      min: 0,
      max: 100
    })
  }
}
